import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {WorkforceTeamCreationState, TeamCreationProgress} from '../../../services/payroll-workforce/workforce-team-creation.state';

@Component({
    selector: 'app-payroll-workforce-progress',
    templateUrl: './payroll-workforce-progress.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PayrollWorkforceProgressComponent {
  @Input() operation: TeamCreationProgress | null = null;
  @Input() scoped = false;
  @Input() creation!: WorkforceTeamCreationState;
}
